import React, { useMemo, useRef, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { useTranslation } from "react-i18next";
import { input } from "@material-tailwind/react";
import { toast } from "react-toastify";
import { updatePassword } from "../../core/service/api_profile";
import { setPriority } from "os";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeOff from "../../assets/images/icon_login/eye-off.svg";
import CustomApp from "../../core/models/customApp";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { isDarkColor } from "../../config/DarkColorChecker";
import { saveChangedPassword } from "../../config/AndroidBridge";
import { isAndroid } from "react-device-detect";

const ComponentChangePassword = () => {
  const gaEventChangeTracker = useAnalyticsEventTracker("EditData");

  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [inputActive, setInputActive] = useState(true);
  const [update, setUpdate] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [data, setData] = useState<any>({});

  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNew2Password, setTypeNew2Password] = useState("password");

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const env = Config.BaseUrlDev;
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const updatePass = async () => {
    if (oldPassword == "")
      return toast.warning(t("CHANGE-PASSWORD.errorOldPass"));
    if (newPassword == "" || newPassword2 == "")
      return toast.warning(t("CHANGE-PASSWORD.errorNewPass"));
    if (newPassword != newPassword2)
      return toast.warning(t("CHANGE-PASSWORD.errorNotMatch"));

    const regexPassword = /^(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{6,}$/;

    if (!newPassword.match(regexPassword) || !newPassword2.match(regexPassword))
      return toast.warning(t("LOGIN.passContain"));

    dispatch(setLoading(true));
    var query = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    updatePassword(query)
      .then((res) => {
        dispatch(setLoading(false));

        toast.success(t("CHANGE-PASSWORD.success"));
        gaEventChangeTracker("Click Change Password", "Change Password");
        setOldPassword("");
        setNewPassword("");
        setNewPassword2("");
        setInputActive(true);
        if(isAndroid){
          saveChangedPassword(query.newPassword);
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNew2Password == "text") {
          setTypeNew2Password("password");
        } else {
          setTypeNew2Password("text");
        }
        break;
    }
  };
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile
          name={`${t("CHANGE-PASSWORD.title")}`}
          backUrl={"profile"}
        ></TabsMobile>
      </div>

      <section className="p-8 pt-0 top-to-bottom">
        <div className="mt-3">
          <div className="flex flex-col gap-2">
            <h1 className="font-montserrat  text-sm text-black leading-5 font-medium pl-1 mb-0">
              {t("CHANGE-PASSWORD.oldPass")}
            </h1>
            <div className="relative w-full flex">
              <input
                type={typeOldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                disabled={inputActive}
                value={oldPassword}
                className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
              />
              <img
                src={typeOldPassword != "text" ? eyeOff : eye}
                className="font-bold text-black absolute z-10 top-2 right-3"
                onClick={() => funTypePassword("old")}
              />
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
              {t("CHANGE-PASSWORD.newPass")}
            </h1>
            <div className="relative w-full flex">
              <input
                type={typeNewPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={inputActive}
                value={newPassword}
                className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
              />
              <img
                src={typeNewPassword != "text" ? eyeOff : eye}
                className="font-bold text-black absolute z-10 top-2 right-3"
                onClick={() => funTypePassword("new")}
              />
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
              {t("CHANGE-PASSWORD.newPass2")}
            </h1>
            <div className="relative w-full flex">
              <input
                type={typeNew2Password}
                disabled={inputActive}
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
                className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
              />
              <img
                src={typeNew2Password != "text" ? eyeOff : eye}
                className="font-bold text-black absolute z-10 top-2 right-3"
                onClick={() => funTypePassword("new2")}
              />
            </div>
          </div>
          <button
            onClick={() => setInputActive(false)}
            hidden={!inputActive}
            style={{ backgroundColor: customApp?.app_secondary_accent_color }}
            className={`px-4 mt-3 font-medium text-sm items-center justify-center bg-yellow w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-yellow-active ${isDarkColor(customApp.app_secondary_accent_color)?'text-white':'text-black'}`}
          >
            {t("OTHER.edit")}
          </button>
          <button
            onClick={() => updatePass()}
            hidden={inputActive}
            style={{ backgroundColor: customApp?.app_accent_color }}
            className={`px-4 mt-3 font-medium text-sm items-center justify-center bg-psp-hover w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
          >
            {t("OTHER.save")}
          </button>
        </div>
      </section>
    </div>
  );
};

export default ComponentChangePassword;
